import React, { useState } from 'react'
import translator from 'src/translate'
import { MButton } from 'src/theme'
import styles from './styles'
import CodeIcon from '@material-ui/icons/Code'
import PhonelinkIcon from '@material-ui/icons/Phonelink'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { TabContext, TabList, TabPanel } from '@material-ui/lab'
import { AssignmentFieldNames } from 'src/model/assignment'
import {
  Card,
  Typography,
  withStyles,
  Grid,
  Tab,
  Switch,
  FormControlLabel,
  Box,
} from '@material-ui/core'
import { CoreButton, CoreTextField } from 'src/components/core'
import URL from 'src/api/url'
import { track } from '@amplitude/analytics-browser'

const EmbedStep = props => {
  const { handleBack, classes, entity } = props
  const [tabValue, setTabValue] = useState(0)
  const [showShareButtons, setShowShareButtons] = useState(0)
  const [copiedEmbedCode, setCopiedEmbedCode] = useState(false)
  const [copiedEmbedCode2, setCopiedEmbedCode2] = useState(false)
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue)
  }
  if (!entity) {
    return null
  }

  let shareCode = showShareButtons ? '?shr=1' : ''

  const onClickEmbedCode = () => {
    track(`course_share_popup_embed_clicked`, {
      type: 'head',
    })

    setCopiedEmbedCode(true)
    setTimeout(() => {
      setCopiedEmbedCode(false)
    }, 500)
  }
  const onClickEmbedCode2 = () => {
    setCopiedEmbedCode2(true)
    track(`course_share_popup_embed_clicked`, {
      type: 'body',
    })

    setTimeout(() => {
      setCopiedEmbedCode2(false)
    }, 500)
  }

  return entity ? (
    <Card className={classes.settingsContainer}>
      <div>
        <TabContext value={tabValue}>
          <TabList
            onChange={handleTabChange}
            TabIndicatorProps={{
              style: { background: '#00AB55' },
            }}
          >
            <Tab
              disableRipple
              label={translator._('assignment.embedCode')}
              value={0}
              icon={<CodeIcon fontSize="small" color="secondary" />}
            />

            <Tab
              disableRipple
              label={translator._('assignment.iframeCode')}
              value={1}
              icon={<PhonelinkIcon fontSize="small" color="secondary" />}
            />
          </TabList>

          <TabPanel value={tabValue} index={0} hidden={tabValue !== 0}>
            <div className={classes.textFields}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={8}>
                  <span>
                    Add the following codes to the {' <head> '} tag of your
                    site.
                  </span>
                  <CoreTextField
                    fullWidth
                    multiline
                    value={
                      '<meta http-equiv="Access-Control-Allow-Origin" content="' +
                      URL.APP_URL +
                      '" />' +
                      '<script src="' +
                      URL.APP_URL +
                      'viewer.js"></script>' +
                      '<script>' +
                      'const app = new MiniCourse();' +
                      'document.addEventListener("DOMContentLoaded", function () {' +
                      'app.init({code: "' +
                      entity[AssignmentFieldNames.CODE] +
                      '", share: ' +
                      (shareCode ? 'true' : 'false') +
                      ', page: 0});' +
                      '});' +
                      '</script>'
                    }
                  />
                  <Typography
                    variant="caption"
                    style={{ color: '#637381', marginTop: 6, display: 'block' }}
                  >
                    Set the page parameter to page: 1 to embed your course
                    directly, bypassing the landing page.
                  </Typography>

                  <CopyToClipboard
                    text={
                      '<meta http-equiv="Access-Control-Allow-Origin" content="' +
                      URL.APP_URL +
                      '" />' +
                      '<script src="' +
                      URL.APP_URL +
                      'viewer.js"></script>' +
                      '<script>' +
                      'const app = new MiniCourse();' +
                      'document.addEventListener("DOMContentLoaded", function () {' +
                      'app.init({code: "' +
                      entity[AssignmentFieldNames.CODE] +
                      '", share: ' +
                      (shareCode ? 'true' : 'false') +
                      ', page: 0});' +
                      '});' +
                      '</script>'
                    }
                    className={classes.copy}
                  >
                    <CoreButton
                      color="primary"
                      variant="outlined"
                      size="medium"
                      onClick={onClickEmbedCode}
                      style={{
                        width: '160px',
                      }}
                    >
                      {copiedEmbedCode ? 'Copied!' : 'Copy to Clipboard'}
                    </CoreButton>
                  </CopyToClipboard>
                </Grid>
                <Grid item xs={12} md={4}>
                  <div className={classes.previewGroup}>
                    <Typography variant="body1">
                      You can embed your site with JavaScript code.
                      <br />
                      Paste the code in the {'<head>'} of your site.
                      <br />
                      <br />
                      Then add the following in the {'<body>'} where you want to
                      show the course:
                      <br />
                      <br />
                      {'<div id="mcg-form-' +
                        entity[AssignmentFieldNames.CODE] +
                        '"></div>'}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={12} md={8}>
                  <span>
                    Add the following codes to the {' <body> '} tag of your
                    site.
                  </span>
                  <CoreTextField
                    fullWidth
                    multiline
                    value={
                      '<div id="mcg-form-' +
                      entity[AssignmentFieldNames.CODE] +
                      '"></div>'
                    }
                  />

                  <CopyToClipboard
                    text={
                      '<div id="mcg-form-' +
                      entity[AssignmentFieldNames.CODE] +
                      '"></div>'
                    }
                    className={classes.copy}
                  >
                    <CoreButton
                      color="primary"
                      variant="outlined"
                      size="medium"
                      onClick={onClickEmbedCode2}
                      style={{
                        width: '160px',
                      }}
                    >
                      {copiedEmbedCode2 ? 'Copied!' : 'Copy to Clipboard'}
                    </CoreButton>
                  </CopyToClipboard>
                  <Box m={3}></Box>
                  <Typography>
                    Have a WordPress website?{' '}
                    <a
                      href="https://wordpress.org/plugins/mini-course-generator/"
                      target="_blank"
                    >
                      Install the WP plug-in to embed easily!
                    </a>
                  </Typography>
                </Grid>
              </Grid>
            </div>
          </TabPanel>

          <TabPanel value={tabValue} index={1} hidden={tabValue !== 1}>
            <div className={classes.textFields}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={8}>
                  <CoreTextField
                    fullWidth
                    multiline
                    value={
                      '<div id="iframe_container" style="width: 100%;position: relative;overflow: hidden;padding-top: 100%;"><iframe id="mcg" name="mcg_frame" title="Mini-Course" src="' +
                      '' +
                      URL.APP_URL +
                      '' +
                      entity[AssignmentFieldNames.CODE] +
                      shareCode +
                      '" align="center" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"  style="position: absolute; width: 100%;height: 100%;top: 0;right: 0;bottom: 0;left: 0;border: none;margin: 0px;padding: 0px;"></iframe></div>'
                    }
                  />

                  <CopyToClipboard
                    text={
                      '<div id="iframe_container" style="width: 100%;position: relative;overflow: hidden;padding-top: 100%;"><iframe id="mcg" name="mcg_frame" title="Mini-Course" src="' +
                      '' +
                      URL.APP_URL +
                      '' +
                      entity[AssignmentFieldNames.CODE] +
                      shareCode +
                      '" align="center"  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"  style="position: absolute; width: 100%;height: 100%;top: 0;right: 0;bottom: 0;left: 0;border: none;margin: 0px;padding: 0px;"></iframe></div>'
                    }
                    className={classes.copy}
                  >
                    <CoreButton
                      color="primary"
                      variant="outlined"
                      size="medium"
                      onClick={onClickEmbedCode}
                      style={{
                        width: '160px',
                      }}
                    >
                      {copiedEmbedCode ? 'Copied!' : 'Copy to Clipboard'}
                    </CoreButton>
                  </CopyToClipboard>
                  <Box m={6}></Box>
                  <Typography>
                    Have a WordPress website?{' '}
                    <a
                      href="https://wordpress.org/plugins/mini-course-generator/"
                      target="_blank"
                    >
                      Install the WP plug-in to embed easily!
                    </a>
                  </Typography>
                </Grid>

                <Grid item xs={12} md={4}>
                  <div className={classes.previewGroup}>
                    <Typography variant="body1">
                      {translator._('assignment.embedCodeInfo')}
                      <br />
                      <br />
                      You can adjust your iframe code using third party tools
                      such as
                      <a target="_blank" href="https://iframe-generator.com">
                        iframe-generator.com
                      </a>
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </div>
          </TabPanel>
        </TabContext>
      </div>
    </Card>
  ) : null
}

export default withStyles(styles)(EmbedStep)
